<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Laboratory Results",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      search_status: false,
      filterdArray: [],
      advancedsearch: {
        search: "",
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
      },
      title: "Laboratory Results Reports",
      items: [
        {
          text: "Laboratory Section",
          href: "#",
        },
        {
          text: "Laboratory Results Reports",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      sampleData: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
          {
              key: "patientCode",
              sortable: true,
              label: "PATIENT No.",
          },
        {
          key: "patientName",
          sortable: true,
          label: "PATIENT NAME",
        },
        // {
        //   key: "branch.name",
        //   sortable: true,
        //   label: "BRANCH",
        // },
        {
          key: "labrequest",
          sortable: false,
          label: "TEST DONE",
        },
        {
          label: "PRINT ALL",
          key: "PrintAll",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("laboratory", ["test_results"]),
    ...mapGetters("auth", ["user_permissions"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.filterdArray ? this.filterdArray.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filterdArray ? this.filterdArray.length : 1;
  },
  watch: {
    test_results(newVal) {
      if (newVal) {
        this.AssignReport();
      }
    },
  },
  methods: {
    sampleModal(dd) {
      let samp = {
        testName: dd.test.name + " sample collection",
        type: "",
        pick_time: "",
        receive_time: "",
        labtest_id: dd.test.id,
      };
      this.sampleData = samp;
      this.FetchSamples(dd.test.id);
    },

    SearchReport() {
      this.search_status = true;
      axios
        .post("filter_testsreport", this.advancedsearch)
        .then((response) => {
          this.search_status = false;
          this.filterdArray = response.data.data;
        })
        .catch(() => {
          this.search_status = false;
        });
    },
    AssignReport() {
      this.filterdArray = this.test_results;
    },
    ...mapActions({
      FetchPending: "laboratory/fetchResultReports",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.FetchPending();
    this.AssignReport();
  },
};
</script>
<style scoped>
.loader-line {
  width: 200px;
  height: 3px;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
  margin: 20px auto;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}
.loader-line:before {
  content: "";
  position: absolute;
  left: -50%;
  height: 3px;
  width: 40%;
  background-color: rgb(0, 4, 255);
  -webkit-animation: lineAnim 1s linear infinite;
  -moz-animation: lineAnim 1s linear infinite;
  animation: lineAnim 1s linear infinite;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

@keyframes lineAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 20%;
    width: 80%;
  }
  100% {
    left: 100%;
    width: 100%;
  }
}
</style>



<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <lable name="date1" for="date1">Filter Start Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date1"
                  class="form-control"
                />
              </div>
              <div class="col-md-3">
                <lable name="date2" for="date2">Filter End Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date2"
                  class="form-control"
                />
              </div>
              <!-- <div class="col-md-3">
                <lable>Name/Code/Contact</lable>
                <input
                  type="text"
                  v-model="advancedsearch.search"
                  class="form-control"
                  placeholder="Search name,code or contact"
                />
              </div> -->
              <div class="col-md-3">
                <br />

                <button v-if="search_status" disabled class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
                <button v-else @click="SearchReport()" class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div v-if="search_status" class="loader-line"></div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                bordered
                class="datatables"
                :items="filterdArray"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                  <template #cell(patientCode)="data">
                      {{ data.item.patient.patientCode }}
                  </template>
                <template #cell(patientName)="data">
                  {{ data.item.patient.patientName }} ({{ data.item.patient.age }})
                  <span
                    class="badge rounded-pill bg-success"
                    v-if="data.item.pay_status == 'Cleared'"
                    >Cleared</span
                  >
                  <span
                    class="badge rounded-pill bg-primary"
                    v-else-if="data.item.pay_status == 'insured'"
                    >Insured</span
                  >
                  <span class="badge rounded-pill bg-danger" v-else>
                    Haven't Cleared</span
                  >
                </template>
                <template #cell(labrequest)="data">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Test Name</th>
                        <th>Date and Time</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(test, t) in data.item.completetests" :key="t">
                        <td>
                          <span v-if="test.spouse">
                            <div style="color: green">
                              {{ test.test.name }}
                              <sup v-show="test.spouse" class="badge bg-success"
                                >Spouse</sup
                              >
                            </div>
                          </span>
                          <span v-else>
                            {{ test.test.name }}
                          </span>
                        </td>
                        <td>{{ test.dateCreated }}</td>
                        <td>
                          <template v-if="user_permissions.print_result==1">
                         <template v-if="data.item.generat_setting.printLabReports==1">
                          <router-link
                            v-if=" data.item.pay_status == 'insured'||
                         data.item.pay_status == 'Cleared'"
                            class="btn btn-success btn-sm"
                            size="sm"
                            :to="{
                              name: 'SingleResults',
                              params: {
                                visit: data.item.id,
                                test: test.test.id,
                              },
                            }"
                          >
                            <i class="fa fa-print"></i> Print
                          </router-link>
                          <button

                            v-else
                            title="You are restricted"
                            class="btn btn-outline-success btn-sm"
                          >
                            <i class="fa fa-ban"></i> Print
                          </button>
                         </template>
                          <template v-else>
                             <router-link
                            class="btn btn-success btn-sm"
                            size="sm"
                            :to="{
                              name: 'SingleResults',
                              params: {
                                visit: data.item.id,
                                test: test.test.id,
                              },
                            }"
                          >
                            <i class="fa fa-print"></i> Print
                          </router-link>
                          </template>
                          </template>
                          <template v-else>
                          <button
                            title="You are restricted"
                            class="btn btn-outline-success btn-sm"
                          >
                            <i class="fa fa-ban"></i> Print
                          </button>
                          </template>
                      

                             <router-link
                            class="btn btn-primary btn-sm m-1"
                            size="sm"
                            :to="{
                              name: 'EditLabTestReports',
                              params: {
                                visit: data.item.id,
                                test: test.test.id,
                                type: test.test.result_type,
                              }, 
                            }"
                          >
                             <i class="fa fa-edit"></i> Edit
                          </router-link>
                        
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
                <template #cell(PrintAll)="data">
                  <template v-if="user_permissions.print_result==1">
                         <template v-if="data.item.generat_setting.printLabReports==1">

                    <router-link
                      class="btn btn-primary btn-sm"
                      size="sm"
                      v-if=" data.item.pay_status == 'insured'||
                         data.item.pay_status == 'Cleared'"
                      :to="{
                        name: 'AllResults',
                        params: { visit: data.item.id },
                      }"
                    >
                      <i class="fa fa-print"></i> Print All
                      {{ data.item.completetests.length }}
                    </router-link>
                         
                          <button
                            v-else
                            title="You are restricted"
                            class="btn btn-outline-success btn-sm"
                          >
                           <i class="fa fa-ban"></i> Print All
                      {{ data.item.completetests.length }}
                          </button>
                         </template>

                          <template v-else>
                             <router-link
                            class="btn btn-success btn-sm"
                            size="sm"
                             :to="{
                        name: 'AllResults',
                        params: { visit: data.item.id },
                      }"
                          >
                            <i class="fa fa-print"></i>  Print All
                      {{ data.item.completetests.length }}
                          </router-link>
                          </template>
                          </template>
                          <template v-else>
                          <button
                            title="You are restricted"
                            class="btn btn-outline-success btn-sm"
                          >
                            <i class="fa fa-ban"></i> Print All
                      {{ data.item.completetests.length }}
                          </button>
                          </template>
               
                </template>
              </b-table>
              <h3 v-if="!test_results" class="text-primary text-center">
                <b-spinner
                  class="m-0"
                  variant="primary"
                  role="status"
                ></b-spinner>
                Please wait...
              </h3>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </Layout>
</template>
